<template>
  <v-dialog v-model="visible" max-width="420px">
    <v-card class="confirm-delete-card" rounded="lg">
      <!-- ヘッダー部分 -->
      <div class="delete-header">
        <div class="icon-wrapper">
          <v-icon size="32" color="white">mdi-alert-circle-outline</v-icon>
        </div>
      </div>

      <!-- タイトル -->
      <v-card-title
        class="delete-title text-center pt-4 pb-2"
        :style="{ color: isDark ? '#fff' : '#333' }"
      >
        <div v-if="titleLines && titleLines.length">
          <div v-for="(line, index) in titleLines" :key="index" class="title-line">
            {{ line }}
          </div>
        </div>
        <div v-else-if="title">{{ title }}</div>
        <div v-else>削除の確認</div>
      </v-card-title>

      <!-- メッセージ -->
      <v-card-text
        class="delete-message text-center px-6 pb-6"
        :style="{ color: isDark ? 'rgba(255, 255, 255, 0.7)' : '#666' }"
      >
        <p class="message-text">{{ message || "この操作は元に戻せません。" }}</p>
      </v-card-text>

      <!-- ボタン -->
      <v-card-actions
        class="delete-actions pa-4 pt-0"
        :style="{ background: isDark ? 'rgba(255, 255, 255, 0.05)' : '#fafafa' }"
      >
        <v-btn
          variant="outlined"
          color="grey-darken-1"
          class="flex-grow-1 mr-2"
          size="large"
          rounded="lg"
          @click="visible = false"
        >
          キャンセル
        </v-btn>
        <v-btn
          color="error"
          class="flex-grow-1 ml-2"
          size="large"
          rounded="lg"
          @click="onConfirm"
        >
          <v-icon start size="small">mdi-delete</v-icon>
          削除する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, computed } from "vue";
import { useTheme } from "vuetify";

const theme = useTheme();
const isDark = computed(() => theme.global.current.value.dark);

const props = defineProps({
  modelValue: Boolean,
  title: String,
  titleLines: Array,
  message: String,
  target: Object, // 削除対象（任意：ファイルやルームなど）
});

const emit = defineEmits(["update:modelValue", "confirm"]);

const visible = ref(props.modelValue);

watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
  }
);
watch(visible, (val) => {
  emit("update:modelValue", val);
});

const onConfirm = () => {
  emit("confirm", props.target);
  visible.value = false;
};
</script>

<style scoped>
.confirm-delete-card {
  overflow: hidden;
}

.delete-header {
  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.delete-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.title-line {
  line-height: 1.4;
}

.message-text {
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

.delete-actions {
  border-top: 1px solid rgba(128, 128, 128, 0.2);
}
</style>
